<template>
    <!--simple display my name-->
    <div>
        <h1 :style="style">{{ name }}</h1>
    </div>
</template>

<script>
    export default {
        name: "Name",
        props: {
            name: String,
            size: {
                type: Number,
                default: 65,
            }
        },
        computed: {
            style() {
                let ratio = 0.7;
                let small = this.$isMobile();

                return `
                font-size: ${small ? (this.size * ratio) : this.size}px;
                `;
            }
        }
    }
</script>

<style scoped>
    h1 {
        color: #333333;
    }
</style>